import { ShimmerElementType } from "@fluentui/react";

export const SHIMMER_LINE_ELEMENT = { type: ShimmerElementType.line, height: 10 };
export const SHIMMER_LINE_ELEMENT_COLOR = { shimmer: "var(--shimmer-color)" };
export const SHIMMER_LINE_ELEMENT_PROPS = { shimmerElements: [{ ...SHIMMER_LINE_ELEMENT }], shimmerColors: SHIMMER_LINE_ELEMENT_COLOR };
export const SHIMMER_DETAILS_DATA = [{ width: "40% !important" }, { width: "80% !important" }, { width: "20% !important" }];
